import Exercise from '@/api/exercise';
import ListeningContent from '@/api/listeningContent';
import ListeningItem from '@/api/listeningItem';
import { isEmpty, isNil } from 'lodash';
import { createMediaField } from '../common/util';

async function copyListeningItem(
  listeningItem: ListeningItem,
  parent_id: number
) {
  const newListeningItem = new ListeningItem();
  newListeningItem.sentence = listeningItem.sentence;
  newListeningItem.transcription = listeningItem.transcription;
  newListeningItem.index = listeningItem.index;
  newListeningItem.parent_exercise = parent_id;

  if (!isEmpty(listeningItem.audio_link)) {
    const mediaId = await createMediaField(
      listeningItem.audio_link,
      parent_id,
      'exercise',
      'audio'
    );

    listeningItem.audio_path = mediaId;
  }

  await listeningItem.save();
  return listeningItem;
}

export async function copyListeningContent(
  exercise: Exercise,
  sourceListeningContent: ListeningContent
) {
  if (isNil(exercise.listening_content) || isNil(sourceListeningContent)) {
    return;
  }

  const listening = exercise.listening_content;
  listening.parent_exercise = exercise.id;
  listening.correct_index = sourceListeningContent.correct_index;

  const jobs = sourceListeningContent.items.map((item) =>
    copyListeningItem(item, exercise.id)
  );

  const listeningItems = await Promise.all(jobs);
  listening.items = listeningItems;

  await listening.save();
}
